import { forwardRef } from "react";

export default forwardRef(function GridIcon ({ width, color, ratio, onClick }, ref) {
  const circleRadius = 2;
  const viewBoxSize = 24;
  const circles = [];
  
  // Calculate the number of circles per row and column based on ratio
  const circlesPerRow = Math.round(Math.sqrt(ratio));
  const circlesPerColumn = Math.round(ratio / circlesPerRow);
  
  // Calculate spacing between circles
  const spacingX = viewBoxSize / (circlesPerRow + 1);
  const spacingY = viewBoxSize / (circlesPerColumn + 1);
  
  // Generate circles
  for (let i = 0; i < circlesPerColumn; i++) {
    for (let j = 0; j < circlesPerRow; j++) {
      const cx = spacingX * (j + 1);
      const cy = spacingY * (i + 1);
      circles.push(<circle key={`${i}-${j}`} cx={cx} cy={cy} r={circleRadius} fill={color}/>);
    }
  }

  return (
    <svg ref={ref} style={{cursor: 'pointer'}} onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`} width={width} height={(width / viewBoxSize) * viewBoxSize} fill={color}>
      {circles}
    </svg>
  );
});
